import React, { memo } from 'react';
import { Blok } from '../../../../interfaces/Blok.interface';
import { LinkProps } from '../../../../interfaces/LinkProps.interface';
import QuoteTotalAndTermsBar from './QuoteTotalAndTermsBar';
import QuoteButtonsBar from './QuoteButtonsBar';

interface QuoteTotalTermsAndButtonsBlokProps extends Blok {
  total_label: string;
  terms_and_conditions_heading: string;
  terms_and_conditions_body: string;
  primary_cta: LinkProps[];
  secondary_cta: LinkProps[];
}

interface QuoteTotalTermsAndButtosProps {
  blok: QuoteTotalTermsAndButtonsBlokProps;
}

const QuoteTotalTermsAndButtons: React.FC<QuoteTotalTermsAndButtosProps> = ({
  blok,
}) => {
  const {
    total_label,
    terms_and_conditions_heading,
    terms_and_conditions_body,
    primary_cta,
    secondary_cta,
  } = blok;

  return (
    <section>
      <QuoteTotalAndTermsBar
        total_label={total_label}
        terms_and_conditions_heading={terms_and_conditions_heading}
        terms_and_conditions_body={terms_and_conditions_body}
      />
      <QuoteButtonsBar
        primary_cta={primary_cta}
        secondary_cta={secondary_cta}
      />
    </section>
  );
};

export default memo(QuoteTotalTermsAndButtons);
